// extracted by mini-css-extract-plugin
export default {"title":"ftbIo","wrap":"e28eR","button":"TvUMI","img":"lVHLG","btn-wrap":"fDGp5"};